// Shared display formatters for ride data. Metric for now (km / km·h⁻¹) — the Belgian
// default; unit-awareness off the speedUnit setting can follow.

export function formatDistanceMeters(meters: number): string {
  return meters >= 1000 ? `${(meters / 1000).toFixed(1)} km` : `${Math.round(meters)} m`;
}

export function formatDurationSeconds(seconds: number): string {
  const total = Math.round(seconds);
  const h = Math.floor(total / 3600);
  const min = Math.floor((total % 3600) / 60);
  if (h > 0) return `${h}h ${min}m`;
  if (min > 0) return `${min}m`;
  return `${total}s`;
}

export function formatSpeedMps(mps: number): string {
  return `${Math.round(mps * 3.6)} km/h`;
}

export function formatRideDate(iso: string): string {
  const d = new Date(iso);
  const date = d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
  const time = d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
  return `${date} · ${time}`;
}
